import React from 'react'
import './Hero.css'
import arrow_icon from '../Assets/arrow.png'


const Hero = () => {
  return (
    <div className='hero'>
        <div className="hero-left">
            <h2>🌞 Temporada Verano</h2>
            <div>
              <p>Aprovechá estas</p>
              <p>ofertas</p>
              <p>especiales</p>
            </div>
        </div>
        <div className="hero-right">

        </div>
    </div>
  )
}
export default Hero